export default "__VITE_ASSET__jnATGih9__"